module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Resize', {
    ref: "resize",
    staticClass: "app-layout",
    class: {
      mobile: _vm.$root.isMobile, 'open-popup': _vm.popup != '' || _vm.$route.path == '/picnic'
    },
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "header",
    class: {
      'hide': _vm.openMenu
    }
  }, [_c('a', {
    staticClass: "logo-a",
    attrs: {
      "href": "https://www.afisha.ru/",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.gaEvents('main', 'click', 'logo afisha')
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "logo-b",
    attrs: {
      "href": "/"
    },
    on: {
      "click": function($event) {
        _vm.gaEvents('main', 'click', 'main')
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "logo",
    attrs: {
      "href": "https://www.weleda.ru/?utm_source=afisha&utm_medium=logo&utm_term=range&utm_content=main_page&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.gaEvents('main', 'click', 'logo weleda')
      }
    }
  }, [_c('Logo')], 1)]), _vm._v(" "), _c('a', {
    staticClass: "open-menu",
    class: {
      'open': _vm.openMenu
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "prevet", undefined, $event.key, undefined)) { return null; }
        return _vm.toggleMenu($event)
      }
    }
  }, [_c('span')]), _vm._v(" "), _c('menu-app', {
    staticClass: "menu",
    on: {
      "closeMenu": _vm.toggleMenu
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "center",
    on: {
      "click": _vm.closeShare
    }
  }, [_c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('router-view', {
    ref: "page"
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "social-block"
  }, [(_vm.openSocial) ? _c('ul', {
    staticClass: "social-list"
  }, [_c('li', [_c('share-link', {
    staticClass: "icon",
    attrs: {
      "network": "fb",
      "url": "http://weleda.afisha.ru/"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaEvents('main', 'click', 'fb')
      }
    }
  }, [_c('fb')], 1)], 1), _vm._v(" "), _c('li', [_c('share-link', {
    staticClass: "icon",
    attrs: {
      "network": "vk",
      "url": "http://weleda.afisha.ru/"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaEvents('main', 'click', 'vk')
      }
    }
  }, [_c('vk')], 1)], 1), _vm._v(" "), _c('li', [_c('share-link', {
    staticClass: "icon",
    attrs: {
      "network": "ok",
      "url": "http://weleda.afisha.ru/"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaEvents('main', 'click', 'ok')
      }
    }
  }, [_c('ok')], 1)], 1), _vm._v(" "), _c('li', [_c('share-link', {
    staticClass: "icon",
    attrs: {
      "network": "tw",
      "url": "http://weleda.afisha.ru/"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaEvents('main', 'click', 'tw')
      }
    }
  }, [_c('tw')], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "open-social",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleSocial($event)
      }
    }
  }, [_c('opensocial')], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dced5584","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 547
// module chunks = 1